export const userManagementData = [
  {
    id: 1,
    code: "3704",
    username: "xxxxxxx",
    name: "xxxxxxx",
    isSuperAdmin: true,
    type: "",
    field: "",
    hospital: "",
    company: "เฮลป์คลินิกเวชกรรม",
    campaign: "HEALRHDELIVER CLINIC2"
  },
  {
    id: 2,
    code: "3703",
    username: "xxxxxxx",
    name: "xxxxxxx",
    isSuperAdmin: true,
    type: "",
    field: "",
    hospital: "",
    company: "เฮลป์คลินิกเวชกรรม",
    campaign: "HEALRHDELIVER CLINIC2"
  },
  {
    id: 3,
    code: "3702",
    username: "xxxxxxx",
    name: "xxxxxxx",
    isSuperAdmin: false,
    type: "",
    field: "",
    hospital: "",
    company: "เฮลป์คลินิกเวชกรรม",
    campaign: "HEALRHDELIVER CLINIC2"
  },
  {
    id: 4,
    code: "3701",
    username: "xxxxxxx",
    name: "xxxxxxx",
    isSuperAdmin: false,
    type: "",
    field: "",
    hospital: "",
    company: "เฮลป์คลินิกเวชกรรม",
    campaign: "HEALRHDELIVER CLINIC2"
  },
  {
    id: 5,
    code: "3700",
    username: "xxxxxxx",
    name: "xxxxxxx",
    isSuperAdmin: false,
    type: "",
    field: "",
    hospital: "",
    company: "เฮลป์คลินิกเวชกรรม",
    campaign: "HEALRHDELIVER CLINIC2"
  }
];
